// This file is generated by pnpm icons:generate. Do not edit.

import {ArrowBoxLeft_Stroke2_Corner0_Rounded as CanonicalArrowBoxLeft_Stroke2_Corner0_Rounded} from './Arrow'

/** @deprecated Import ArrowBoxLeft_Stroke2_Corner0_Rounded from `#/components/icons/Arrow` instead. */
export const ArrowBoxLeft_Stroke2_Corner0_Rounded =
  CanonicalArrowBoxLeft_Stroke2_Corner0_Rounded
